import React from "react";
import { Link } from "react-router-dom";
const img = require("../../assests/AnilDhyani.jpeg");

export default function OurStory() {
  return (
    <div className="flex flex-col gap-6 md:gap-1 md:flex-row items-center w-full px-6 py-12 max-w-screen-xl mx-auto bg-[#F9FAFB]">
      {/* Left Section - Story Text */}
      <div className="md:w-[55%] text-left space-y-6 pr-8">
        {/* Title */}
        <h2 className="text-goldenYellow font-bold text-4xl md:text-5xl leading-tight">
          Our Story
        </h2>

        {/* Paragraphs */}
        <p className="text-gray-500 leading-relaxed">
          Established in 1992, Anil Dhyani & Associates has been providing exceptional legal
          services for over 30 years. With a strong foundation built on expertise, integrity,
          and innovation, we have earned a reputation for delivering strategic and effective
          legal solutions across diverse practice areas.
        </p>
        <p className="text-gray-500 leading-relaxed">
          Our dynamic team of civil, criminal, corporate, taxation, family, IT, startup, and
          intellectual property (IP) lawyers is dedicated to delivering comprehensive legal
          solutions. We take a creative approach, ensuring tailored strategies for our clients’ needs.
        </p>

        {/* Read More Button */}
        <Link to="/about" className="text-goldenYellow font-semibold mt-4 flex items-center hover:underline transition duration-300">
          Read More →
        </Link>
      </div>

      {/* Right Section - Image & Bio Box */}
<div className="md:w-[45%] bg-[#0F172A] p-8 rounded-2xl shadow-xl border border-gray-700">
  <div className="flex flex-col md:flex-row items-center gap-6">
    {/* Image */}
    <div className="w-32 h-32 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-goldenYellow shadow-md">
      <img
        src={img}
        alt="Anil Dhyani"
        className="w-full h-full object-cover"
      />
    </div>

    {/* Bio */}
    <div className="flex-1 text-white space-y-4 text-center md:text-left">
      <h3 className="font-bold text-2xl text-goldenYellow">Anil Dhyani</h3>
      <p className="text-gray-300 text-sm leading-relaxed">
        Since establishing his law firm in 1992, Anil Dhyani has committed 
        himself to providing the best possible legal representation to his clients.
      </p>
      <p className="text-gray-400 text-sm italic">
        “Take Care of People.” – A time-tested principle guiding our firm.
      </p>

      {/* Read More Button */}
      <div className="mt-4">
        <Link to="/about" className="px-6 py-2 bg-goldenYellow text-[#0F172A] font-semibold rounded-full shadow-lg hover:bg-[#E5BF00] transition duration-300">
          Read More
        </Link>
      </div>
    </div>
  </div>
</div>

    </div>
  );
}